import { ChakraText as Text, ChakraCheckbox as Checkbox, ChakraFlex as Flex } from "@airhelp/react-ui-components";
import type { MarketingConsentProps } from "./MarketingConsent.d";

const MarketingConsent = ({ register, text, ...props }: MarketingConsentProps) => (
  <Flex alignItems="flex-start" {...props} mb={{ base: 6, md: 0 }}>
    <Checkbox isRequired name="marketingConsent" aria-labelledby="marketing-consent" ref={register} size="lg" mr={2} />
    <Text id="marketing-consent" color="inherit" fontSize="sm" textAlign="start">
      {text}
    </Text>
  </Flex>
);

export default MarketingConsent;
